/*
 * Created by jmeo at 2021-05-11
 * FileName: ImageUploader.tsx
 * 图片资源上传组件
 */
import React, {ChangeEvent} from "react";
import AsyncImg from "./AsyncImg";
import {base64ToBlob, isEmpty, isIOS} from "@src/util";
import {Toast} from "antd-mobile";
import request from "@util/request";
import API from "@src/constant/api";

export type OssItemType = {
	id: number
	osskey: string
	osskeySmall: string
}

type ImageLoaderProps = {
	label?: string,
	src?: string,
	onChange?: (e: OssItemType) => void,
	onRemove?: () => void,
	onImageClick?: () => void,
	onFail?: () => void,
	accept?: string;
	length?: number | string;
	disableDelete?: boolean;
	children?: any;
	className?: any;
	style?: any;
	preview?: boolean,
	previewSrc?: any
}

/**
 * 单文件组件
 */
export default class ImageLoader extends React.Component<ImageLoaderProps, any> {

	imgInputRef: HTMLInputElement | null = null

	constructor(props: any) {
		super(props);
		this.state = {
			src: null
		}
	}

	static getDerivedStateFromProps(preProps: ImageLoaderProps) {
		return {
			src: preProps.src
		}
	}

	onClick() {
		this.imgInputRef?.click()
	}

	inputOnchange(e: ChangeEvent) {
		const target: any = e.target
		const files = target.files;
		//  upload the file and show it
		if (files.length <= 0) return
		const file = files[0]
		// 预览图片
		if (this.props.preview) {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				this.setState({
					src: reader.result
				})
			}
		}
		Toast.show({icon: 'loading', content: '请等待图片上传完成！', duration: 0})
		//  upload handle
		uploadFile(file).then((rs: OssItemType) => {
			this.props.onChange && this.props.onChange(rs)
		}).finally(() => {
			Toast.clear()
		})
	}

	onRemove(e: any) {
		e.stopPropagation()
		e.preventDefault();
		this.setState({
			src: null
		})
		if (this.imgInputRef) {
			this.imgInputRef.value = ""
		}
		this.props.onRemove && this.props.onRemove()
	}


	render() {
		const {src} = this.state
		const props = this.props
		const {className, style} = props
		const _className = ['cfImageLoader']
		className && _className.push(className)

		return <div
			className={_className.join(' ')}
			style={style}
			onClick={this.onClick.bind(this)}>
			<input type="file"
				   style={{display: 'none'}}
				   accept="image/*"
				   onChange={this.inputOnchange.bind(this)}
				   ref={(e) => {
					   this.imgInputRef = e
				   }}/>
			{/*   预览图片    */}
			{src && <AsyncImg src={src} contain="true" showsrc={props.previewSrc || src}/>}
			{/* 当没有加载图片当时候，展示默认 */}
			{!src && props.children}
			{/* 删除图片按钮 */}
			{src && <div className="btnRemove" onClick={this.onRemove.bind(this)}/>}
		</div>;
	}

}


/**
 * 上传文件
 * @param file
 */
export function uploadFile(file: any) {
	return request.post<any>(API.ASSURE_IMG_UPLOAD, {img: file})
}